export default __webpack_public_path__ + "static/media/AdobeStock_323832194.2c105baf.mp4";